import { ToggleButton, ToggleButtonGroup } from "@mui/material";
import { getLang, setLang } from "../../services/translation";

export default function LanguageSwitcher() {
    const value = getLang();

    const handleChange = (_, value) => {
        if (!value) return;
        setLang(value);
        window.location.reload();
    }
    return (
        <ToggleButtonGroup
            value={value}
            exclusive
            onChange={handleChange}
            size="small"
            aria-label="language switcher"
            sx={groupSx}
        >
            <ToggleButton value="fr" aria-label="français" sx={buttonSx}>
                <img src="https://flagcdn.com/w20/fr.png" alt="FR" width="22" />
            </ToggleButton>
            <ToggleButton value="en" aria-label="anglais" sx={buttonSx}>
                <img src="https://flagcdn.com/w20/gb.png" alt="FR" width="22" />
            </ToggleButton>
        </ToggleButtonGroup>
    );
}

const groupSx = {
    borderColor: 'transparent'
}

const buttonSx = {
    py: '4px',
    px: '6px',
    color: "white",
    borderColor: 'transparent',
    backgroundColor: "rgba(255,255,255,0.2)",

    "&.Mui-selected": {
        backgroundColor: "rgba(255,255,255,0.6)",
        color: "white",
    },

    "&:hover": {
        backgroundColor: "rgba(255,255,255,0.4)",
    },
};